import { Icon } from './Icon';

export interface Crumb {
  label: string;
  href?: string;
}

/** Hierarchy trail at the top of a page; every segment but the last is a link. */
export function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav class="crumbs" aria-label="Breadcrumb">
      {items.map((c, i) => (
        <span key={i} class="crumb">
          {i > 0 && <Icon name="chevronRight" size={12} class="sep" />}
          {c.href && i < items.length - 1 ? <a href={c.href}>{c.label}</a> : <span aria-current={i === items.length - 1 ? 'page' : undefined}>{c.label}</span>}
        </span>
      ))}
    </nav>
  );
}
